import React, { useState, useEffect } from "react";

export const WithButton = (WrappedInput) => (props) => {
    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [reset, setReset] = useState(false);

    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (reset) {
            setReset(false);
        }
    }, [reset]);

    const buttonClick = (e) => {
        setReset(true);

        if (props.buttonClick) {
            props.buttonClick(e);
        }
    };

    const handleEnter = (e) => {
        if (e.which === 13 || e.keyCode === 13) {
            buttonClick(e);

            return false;
        }
    };

    const buttonText = props.buttonText ? props.buttonText : "+";
    const buttonClass = props.buttonClass ? props.buttonClass : "button -primary";

    return (
        <div className="input-group">
            <WrappedInput onKeyPress={handleEnter} defaultValue={reset ? "" : null} {...props} />
            {!props.disabled && (
                <button className={buttonClass} onClick={buttonClick}>
                    {buttonText}
                </button>
            )}
        </div>
    );
};
